export const spectoCalendarTranslations = {
  'spectoCalendarTranslations.linkEmployerDashboard': 'Namizje',
  'spectoCalendarTranslations.linkInterviewInvitation': 'Vabilo na intervju',
  'spectoCalendarTranslations.linkSearchCandidates': 'Iskanje kandidatov ',
  'spectoCalendarTranslations.linkCandidateDashboard': 'Namizje',
  'spectoCalendarTranslations.linkAllRequests': 'Vsi zahtevki',
  'spectoCalendarTranslations.linkEditCV': 'Življenjepis',
}
